<template>
  <CustomPage title="我的优惠券" style="background: #f7f7f7" backRoute="Mine">
    <div slot="content" style="height: 100%">
      <div class="coupon-container pt-3">
        <div
          class="flex flex-wrap justify-evenly text-center text-sm"
          style="height: 35px"
        >
          <div class="box-border w-1/4 flex justify-center">
            <div
              class="rounded-full font-light my-1 py-1"
              :class="{ active: status === '0' }"
              style="width: 6rem; background-color: #eeeeee"
              @click="status = '0'"
            >
              未使用{{ status === '0' ? '(' + couponListLength + ')' : '' }}
            </div>
          </div>
          <div class="box-border w-1/4 flex justify-center">
            <div
              class="rounded-full font-light my-1 py-1"
              :class="{ active: status === '1' }"
              style="width: 6rem; background-color: #eeeeee"
              @click="status = '1'"
            >
              已使用{{ status === '1' ? '(' + couponListLength + ')' : '' }}
            </div>
          </div>
          <div class="box-border w-1/4 flex justify-center">
            <div
              class="rounded-full font-light my-1 py-1"
              :class="{ active: status === '2' }"
              style="width: 6rem; background-color: #eeeeee"
              @click="status = '2'"
            >
              已过期{{ status === '2' ? '(' + couponListLength + ')' : '' }}
            </div>
          </div>
        </div>

        <!-- //各种类型优惠券 -->
        <welfareTicketContent
          v-for="(value, keyVaule) in couponList"
          :key="keyVaule"
          :type="keyVaule"
          :ticketArr="value"
        >
          <div slot="ticketContent">
            <div
              class="overflow-y-auto"
              style="max-height: calc(100vh - 120px)"
            >
              <div
                v-for="(item, index) in value[1]"
                :key="index"
                class="
              rounded-lg
              overflow-hidden
              lightshadow
              flex flex-row
              text-white
              items-center
              justify-between
              h-24
              ticketItemBottom
            "
                :style="{
                  backgroundColor:
                    status === '0' &&
                    (item.relationType === 'activity' ||
                      item.relationType === 'goods')
                      ? '#fff4f4'
                      : status === '0' && item.relationType === 'all'
                      ? '#ffdada'
                      : status === '0' && item.relationType === 'brand'
                      ? '#fff3de'
                      : '#f8f8f8',
                }"
              >
                <div style="width: 150px;" class="ticketItemLeft">
                  <div>
                    <span class="text-xl">¥</span
                    ><span
                      class="leading-10 font-semibold"
                      style="letter-spacing: 0.1rem; font-size: 2.5rem"
                      >{{ item.coupon.faceValue }}</span
                    >
                  </div>
                  <div class="text-xs">
                    满{{
                      item.coupon.threshold ? item.coupon.threshold : '任意'
                    }}元可用
                  </div>
                </div>
                <div class="text-left flex-grow ml-3">
                  <div class="text-black text-sm mb-1">
                    {{ item.coupon.couponName }}
                  </div>
                  <div class="text-xs">
                    {{ item.coupon.startDate }} - {{ item.coupon.endDate }}
                  </div>
                  <div class="text-red text-xs">{{ item.actName }}</div>
                </div>

                <div v-if="status === '0'" class="ticketRight">
                  <div class="differentRangeTicket">
                    <span>{{
                      item.relationType === 'activity'
                        ? '活动券'
                        : item.relationType === 'goods'
                        ? '商品券'
                        : item.relationType === 'all'
                        ? '平台福利券'
                        : item.relationType === 'brand'
                        ? '品牌券'
                        : null
                    }}</span>
                  </div>

                  <Button
                    class="w-12 self-end flex-shrink-0"
                    style="
                padding-left: 6px;
                padding-right: 6px;
                margin-bottom: 0.75rem;
                margin-right: 0.75rem;
              "
                    type="danger"
                    round
                    plain
                    color="red"
                    size="mini"
                    @click="goUse(item.coupon, item)"
                    >去使用</Button
                  >
                </div>

                <img
                  class=""
                  v-else
                  :src="
                    status === '1'
                      ? require('@/assets/coupon/yishiyong.svg')
                      : require('@/assets/coupon/yiguoqi.svg')
                  "
                  alt=""
                />
              </div>
            </div></div></welfareTicketContent
        ><Button
          round
          style="background: #e89a52; width: 80%; margin: 0 10%"
          size="large"
          @click="$router.push({ name: 'CouponCenter' })"
          ><span class="text-white">去领券</span></Button
        >
      </div>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from '@/components/custom-page.vue'
import { Button } from 'vant'
import { getMyCoupon } from './webApi'
import welfareTicketContent from '@/components/welfareTicketContent'
export default {
  components: { CustomPage, Button, welfareTicketContent },
  created() {
    this.getMyCoupon()
  },

  computed: {
    couponListLength() {

      let sum = 0
      for (const item in this.couponList) {
        if (this.couponList[item][1]) {
          sum += this.couponList[item][1].length
        }
      }
      return sum
    },
  },
  data() {
    return {
      status: '0',
      couponList: {},
      activityData: {},
      brandData: {},
      allPlatData: {},
    }
  },
  methods: {
    getMyCoupon() {

      getMyCoupon({ couponStatus: this.status }).then(({ data }) => {

        console.log('---getMyCoupon------', data)
        // this.couponList = data
        // const c = { all: [null, []], a1: ['img', []], a2: ['img', []] }
        const activityData = {}
        const brandData = {}
        const allPlatData = {}
        data.map((item) => {
          const activitylArr = []

          if (item.relationType === 'activity') {
            activitylArr[1] = item.myCoupons
            activitylArr[0] = item.actBannerImg

            activityData[item.actName] = activitylArr
            this.activityData = activityData

          } else if (item.relationType === 'brand') {
            activitylArr[1] = item.myCoupons
            activitylArr[0] = item.brandImg

            brandData[item.brandName] = activitylArr
            this.brandData = brandData
          } else if (item.relationType === 'all') {

            activitylArr[1] = item.myCoupons
            activitylArr[0] = null

            allPlatData.all = activitylArr
            this.allPlatData = allPlatData
          }
        })
        // console.log(
        //   '----this.activityData----',
        //   this.activityData,
        //   '----this.brandData----',
        //   this.brandData,
        //   '----this.allPlatData----',
        //   this.allPlatData
        // )

        this.couponList = { ...activityData, ...brandData, ...allPlatData }

        // console.log('this.couponList-abc', this.couponList)
      })
    },
    goUse(item, itemBigObj) {
      // console.log('------item, itemBigObj-----', item, itemBigObj)

      switch (item.relationType) {
        case 'activity':
          this.$router.push({
            name: 'ActivityPlace',
            params: { aid: item.actId },
          })
          break

        case 'goods':
          this.$router.push({
            name: 'GoodsDetail',
            params: { id: itemBigObj.partGoodsId },
          })
          break
        case 'all':
          this.$router.push('/')
          break
        case 'brand':
          this.$router.push({
            name: 'BrandPlace',
            params: { partId: itemBigObj.partId },
            query: {
              actId: item.actId,
              brandLogo: item.brandLogo,
              signBrandId: item.signBrandId,
            },
          })
          break

        default:
          break
      }
    },
  },
  watch: {
    status() {
      this.getMyCoupon()
    },
  },
}
</script>

<style lang="less" scoped>
.active {
  background-color: #d8283b !important;
  color: #fff;
}

.ticketItemBottom {
  margin-bottom: 20px;
  padding-left: 40px;
  color: #e82035;
  &:nth-last-child(1) {
    margin-bottom: 0px;
  }

  .ticketItemLeft {
    .moneySymbol {
      margin-right: 4px;
    }
  }

  .ticketRight {
    height: 100%;
    .differentRangeTicket {
      width: 140px;
      height: 32px;
      background: #ffe3e6;
      border-radius: 0px 12px 0px 12px;
      margin-bottom: 16px;
      font-size: 22px;
      text-align: center;
    }
  }
}
</style>
